import React, { createContext, useContext, useState, useCallback } from 'react';

const TenantScopeContext = createContext(null);
const KEY = 'gd-scope-tenant';

export function TenantScopeProvider({ children }) {
  const [scopeTenant, setScopeTenantState] = useState(() => {
    try {
      const v = localStorage.getItem(KEY);
      return v ? JSON.parse(v) : null;
    } catch {
      return null;
    }
  });

  const setScopeTenant = useCallback((t) => {
    setScopeTenantState(t);
    try {
      if (t) localStorage.setItem(KEY, JSON.stringify(t));
      else localStorage.removeItem(KEY);
    } catch {}
  }, []);

  const value = {
    scopeTenant,
    setScopeTenant,
    scopeCommuneId: scopeTenant?.commune_id || null,
  };

  return <TenantScopeContext.Provider value={value}>{children}</TenantScopeContext.Provider>;
}

export function useTenantScope() {
  const ctx = useContext(TenantScopeContext);
  if (!ctx) throw new Error('useTenantScope must be used inside TenantScopeProvider');
  return ctx;
}
